import React from 'react';
import { FadeIn } from './FadeIn';
import { PenLine, Filter, CalendarCheck } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    title: 'Proyecta',
    desc: 'Extrae cada pensamiento, por pequeño que sea, al papel sin juzgar.',
    icon: PenLine,
    num: '01'
  }, {
    title: 'Filtra',
    desc: 'Clasifica instantáneamente qué es una acción real y qué es ruido emocional.',
    icon: Filter,
    num: '02'
  }, {
    title: 'Ubica',
    desc: 'Asigna un horario de procesamiento para mañana, permitiendo que tu cerebro suelte la guardia.',
    icon: CalendarCheck,
    num: '03'
  }];
  return <section className="py-24 bg-stone-950 px-4 sm:px-6 lg:px-8" data-id="element-141">
      <div className="max-w-6xl mx-auto" data-id="element-142">
        <FadeIn className="text-center mb-16" data-id="element-143">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-144">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-145">
          {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} direction="up" data-id="element-146">
              <div className="relative bg-stone-900 border border-stone-800 rounded-3xl p-8 h-full group hover:border-amber-500/50 transition-all" data-id="element-147">
                <div className="absolute -top-6 -right-6 text-8xl font-black text-stone-800/30 group-hover:text-amber-900/20 transition-colors pointer-events-none" data-id="element-148">
                  {step.num}
                </div>
                <div className="w-14 h-14 rounded-2xl bg-amber-500/10 flex items-center justify-center mb-6 border border-amber-500/20" data-id="element-149">
                  <step.icon className="w-7 h-7 text-amber-400" data-id="element-150" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-151">
                  {step.title}
                </h3>
                <p className="text-stone-400 leading-relaxed" data-id="element-152">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}